import { RefSerializer, Collection } from "@tblabs/truffle";


export abstract class RefConverter<R, T>
{
    protected abstract ConvertToRaw(obj: T): R | null;
    protected abstract ConvertFromRaw(raw: R): T | null;

    public ToRaw(target: T): R | null
    {
        try
        {
            return this.ConvertToRaw(target);
        }
        catch (ex: any)
        {
            console.error(`Conversion to raw problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nObject:`, target);
            return null;
        }
    }

    public FromRaw(raw: R): T | null
    {
        try
        {
            return this.ConvertFromRaw(raw);
        }
        catch (ex: any)
        {
            console.error(`Conversion from raw problem: ${ex.message}\n\nStack trace: ${ex.stack}\n\nRaw:`, raw);
            return null;
        }
    }

    protected GetCollection<R, T>(value: R[], creator: (raw: R) => T): Collection<T>
    {
        const items = value?.map(x => creator(x));

        return new Collection<T>(items);
    }

    protected GetArray<R, T>(value: R[], creator: (raw: R) => T): Array<T>
    {
        const items = value?.map(x => creator(x));

        return items || [];
    }

    protected GetString(value: any): string
    {
        return value || "";
    }

    protected GetNumber(value: any): number
    {
        return +value || 0;
    }

    protected GetBool(value: any): boolean
    {
        return !!value || false;
    }

    protected GetDate(date: any): Date
    {
        return date ? new Date(date) : new Date(0);
    }
}
